import axios from 'axios';

export default async function consultaUser(ENVIRONMENT, accessToken) {
  let dadosUsuario;

  try {
    dadosUsuario = await axios.get(
      `https://api.${ENVIRONMENT}/api/v2/users/me`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );
    return dadosUsuario;
  } catch (error) {
    console.log('Erro ' + error);
  }
}
